import { useSelector } from 'react-redux';
import { getCaseList } from '../ducks';

export const useGetCaseListData = () => ({
  casesData: useSelector(getCaseList),
});
